export default __webpack_public_path__ + "static/media/office1-after1-2048w.6c10d23e.png";